import React from 'react';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import Row from 'src/components/10-atoms/layout/Row';
import RowCenter from 'src/components/10-atoms/layout/RowCenter';
import Pressable from 'src/components/10-atoms/pressables/Pressable';
import { PRESSABLE_SIZE } from 'src/components/templates/PressableArea';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import useListViewMode from 'src/hooks/useListViewMode';
import useI18n from 'src/modules/translations/hooks/useI18n';
const ListViewModeToggle = ({ title }) => {
    const [{ deviceType, theme }] = useTheme();
    const { isSplitView, setListViewMode } = useListViewMode();
    const { translate } = useI18n();
    if (!deviceType.isDesktop) {
        return null;
    }
    const label = title || translate('Split view');
    return (React.createElement(Row, { yAxis: "center", spacing: theme.spacing.standard.sm },
        React.createElement(Pressable, { style: { width: PRESSABLE_SIZE, height: PRESSABLE_SIZE }, accessibilityLabel: label, onPress: () => setListViewMode(isSplitView ? 'list' : 'split') },
            React.createElement(RowCenter, { flex: true, bg: isSplitView ? theme.palette.primary.subtle : undefined, brd: PRESSABLE_SIZE },
                React.createElement(FeatherIcon, { name: "layout", size: theme.iconSize.sm, color: isSplitView
                        ? theme.palette.primary.main
                        : theme.palette.icon.primary })))));
};
export function useListViewModeNavbarAction() {
    const [{ deviceType }] = useTheme();
    const { translate } = useI18n();
    if (!deviceType.isDesktop) {
        return undefined;
    }
    return {
        title: translate('Split view'),
        render: ListViewModeToggle,
    };
}
export { ListViewModeToggle };
